import { createSlice } from "@reduxjs/toolkit";
import { API_STATUS } from "../../../constants/apiStatus";
import {
  getDietPreferencesAction,
  updateDietPreferencesAction,
  getAllDietOptionsAction,
} from "./dietPreferencesSliceActions";
import { dietPreferencesSliceInitialState } from "./dietPreferencesSliceInitialState";

const initialState = dietPreferencesSliceInitialState;

const dietPreferencesSlice = createSlice({
  name: "dietPreferences",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    updatePreferenceField: (state, action) => {
      if (state.preferences) {
        state.preferences[action.payload.field] = action.payload.value;
      }
    },
    togglePreference: (state, action) => {
      if (state.preferences && state.preferences.selectedOptions) {
        const optionId = action.payload;
        const index = state.preferences.selectedOptions.indexOf(optionId);
        if (index > -1) {
          state.preferences.selectedOptions.splice(index, 1);
        } else {
          state.preferences.selectedOptions.push(optionId);
        }
      }
    },
    resetDietPreferencesState: () => initialState,
  },
  extraReducers: (builder) => {
    // Get Diet Preferences
    builder.addCase(getDietPreferencesAction.fulfilled, (state, action) => {
      state.apiStatus.getPreferences = API_STATUS.COMPLETED;
      state.preferences = action.payload;
      state.error = null;
    });
    builder.addCase(getDietPreferencesAction.pending, (state) => {
      state.apiStatus.getPreferences = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(getDietPreferencesAction.rejected, (state, action) => {
      state.apiStatus.getPreferences = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Update Diet Preferences
    builder.addCase(updateDietPreferencesAction.fulfilled, (state, action) => {
      state.apiStatus.updatePreferences = API_STATUS.COMPLETED;
      state.preferences = action.payload;
      state.error = null;
    });
    builder.addCase(updateDietPreferencesAction.pending, (state) => {
      state.apiStatus.updatePreferences = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(updateDietPreferencesAction.rejected, (state, action) => {
      state.apiStatus.updatePreferences = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Get All Diet Options
    builder.addCase(getAllDietOptionsAction.fulfilled, (state, action) => {
      state.apiStatus.getAllOptions = API_STATUS.COMPLETED;
      state.allOptions = action.payload;
      state.error = null;
    });
    builder.addCase(getAllDietOptionsAction.pending, (state) => {
      state.apiStatus.getAllOptions = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(getAllDietOptionsAction.rejected, (state, action) => {
      state.apiStatus.getAllOptions = API_STATUS.FAILED;
      state.error = action.payload;
    });
  },
});

export const {
  clearError,
  updatePreferenceField,
  togglePreference,
  resetDietPreferencesState,
} = dietPreferencesSlice.actions;

export default dietPreferencesSlice.reducer;
